import { render } from "./about_us.vue?vue&type=template&id=6bd4984d"
import script from "./about_us.vue?vue&type=script&lang=js"
export * from "./about_us.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__